<script setup>
import ProForecastPage from '@/components/ProForecastPage.vue';

</script>

<template>
  <Suspense>
    <ProForecastPage />
  </Suspense>
</template>
